import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useInstructorPermissions } from '../hooks/useInstructorPermissions';

const InstructorScenarioBuilder = () => {
  const { currentUser, userRole } = useAuth();
  const { permissions, loading: permissionsLoading } = useInstructorPermissions(currentUser?.uid);

  // Check permissions
  if (!currentUser || (userRole !== 'Instructor' && userRole !== 'Admin' && userRole !== 'owner')) {
    return (
      <div className="min-h-screen bg-bg text-text flex flex-col items-center justify-center py-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4 text-red-600">Access Denied</h1>
          <p className="text-lg">You don't have permission to access this page.</p>
        </div>
      </div>
    );
  }

  // Check if instructor has scenario builder permission
  if (userRole === 'Instructor' && (!permissions || permissions.scenarioBuilder === 'none')) {
    return (
      <div className="min-h-screen bg-bg text-text flex flex-col items-center justify-center py-8">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4 text-red-600">No Access</h1>
          <p className="text-lg">You don't have access to scenario builder. Please contact your administrator.</p>
          <button
            onClick={() => window.history.back()}
            className="mt-4 bg-primary text-white px-4 py-2 rounded shadow hover:bg-secondary hover:text-primary font-semibold transition duration-200"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  if (permissionsLoading) {
    return (
      <div className="min-h-screen bg-bg text-text flex items-center justify-center">
        <div className="text-lg">Loading scenario builder...</div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-bg text-text flex flex-col items-center justify-center py-8">
      <h1 className="text-2xl font-bold mb-4 text-primary">Scenario Builder</h1>
      <p className="text-lg mb-8 text-center max-w-2xl">
        Coming soon! The scenario builder for instructors is currently being developed.
      </p>
      
      <Link
        to="/instructor-dashboard"
        className="bg-primary text-white px-6 py-3 rounded-lg shadow hover:bg-secondary hover:text-primary font-semibold transition duration-200"
      >
        Back to Dashboard
      </Link>
    </div>
  );
};

export default InstructorScenarioBuilder;
